import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Candle } from "@/components/Candle";
import { Header } from "@/components/Header";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { Flame, Heart, Infinity as InfinityIcon } from "lucide-react";

export default function Ambassador() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    if (loading) return;
    if (!user) { navigate("/?auth=register", { replace: true }); return; }
    // Plus de bougie offerte -> l'accueil devient le site traditionnel
    if ((user.free_eternal_candles || 0) <= 0) navigate("/", { replace: true });
  }, [loading, user, navigate]);

  const firstName = user?.first_name || (user?.name || "").split(" ")[0] || "";
  const credit = user?.free_eternal_candles || 0;

  return (
    <div className="relative flex min-h-[100dvh] flex-col bg-black" data-testid="ambassador-welcome">
      <Header />

      <div className="mx-auto flex w-full max-w-lg flex-1 flex-col items-center px-6 pb-28 text-center fade-in">
        <div className="relative my-2">
          <Candle progress={1} size="min(340px, 30vh)" />
        </div>

        <h1 className="mt-1 text-2xl font-medium leading-tight sm:text-3xl" data-testid="ambassador-title">
          {t("ambassador.welcomeTitle", { name: firstName })}
        </h1>
        <p className="mt-3 max-w-md text-base leading-relaxed text-white/90" data-testid="ambassador-intro">
          {t("ambassador.intro")}
        </p>

        <div className="mt-4 w-full rounded-3xl border border-amber-400/20 bg-black p-5 text-left" data-testid="ambassador-gift">
          <div className="flex items-center gap-2 text-amber-300">
            <InfinityIcon size={18} />
            <span className="text-base font-semibold">{t("ambassador.giftTitle", { count: credit })}</span>
          </div>
          <p className="mt-2 text-sm text-white/80">
            {t("ambassador.giftText")}
          </p>
        </div>

        <Button
          onClick={() => navigate("/mes-bougies")}
          className="mt-6 flex h-14 w-full max-w-md items-center justify-center rounded-full text-lg font-semibold shadow-[0_4px_24px_0_rgba(56,189,248,0.45)] transition-transform hover:scale-[1.02]"
          data-testid="ambassador-light-btn"
        >
          <Flame size={22} className="mr-2" /> {t("ambassador.lightButton")}
        </Button>
        <p className="mt-3 flex items-center justify-center gap-1.5 text-sm text-muted-foreground">
          <Heart size={13} className="text-sky-400" /> {t("ambassador.freeForever")}
        </p>
      </div>
    </div>
  );
}
